import React, { InputHTMLAttributes } from 'react'
import { ReUnixCron } from '@sbzen/re-cron'
import Input from '@/components/ui/Input'
import FormHelperText from '@/components/ui/FormHelperText'
import { useField } from 'formik'
import { Links } from '@/config/app'
import Button from '@/components/ui/Buttons/Button'
import './CronInput.scss'
import { CronInputTabOptions, useActiveTab, useCronInputValues } from '@/components/CronInput/CronInput.hooks'

export type CronInputProps = InputHTMLAttributes<HTMLInputElement> & {
  name: string
}

const CronInput = ({ name }: CronInputProps) => {
  const [field, { error }] = useField(name)
  const [activeTab, setActiveTab] = useActiveTab()
  const [cronValue, setCronValue] = useCronInputValues(name)

  return (
    <div>
      <div className={'c-unix-header'}>
        {CronInputTabOptions.map((tab) => (
          <Button key={tab.value} onClick={() => setActiveTab(tab)} color={'neutral'} isActive={activeTab === tab}>
            {tab.label}
          </Button>
        ))}
      </div>
      {activeTab.value === 'ADVANCED' ? (
        <>
          <Input {...field} color={error ? 'danger' : undefined} />
          <FormHelperText color={error ? 'danger' : undefined}>
            {error ?? 'Crontab config that defines when to run the route'}. See more{' '}
            <a href={Links.crontabGuruGuide} target={'_blank'} rel={'noreferrer'}>
              here
            </a>
          </FormHelperText>
        </>
      ) : (
        <ReUnixCron
          value={cronValue}
          onChange={setCronValue}
          cssClassPrefix={'CronInput-'}
          hideTabs
          activeTab={activeTab.value}
        />
      )}
    </div>
  )
}

export default CronInput
